import { render, staticRenderFns } from "./ActivityProject.vue?vue&type=template&id=0996023a&scoped=true&"
import script from "./ActivityProject.vue?vue&type=script&lang=js&"
export * from "./ActivityProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0996023a",
  null
  
)

export default component.exports